import t from 'ember-intl/helpers/t';
import { pageTitle } from 'ember-page-title';
<template>{{pageTitle (t "general.logout")}}</template>
